/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { SimpliCitySDK } from "cms/sdk";
import { isValidGuid } from "cms/utils/empty-exists";

export const generateImageSlide = async (images, token) => {
    const imageSlides = await Promise.all(
        images.filter((_image) => isValidGuid(_image?.value))
            .map(async (_image) => {
                const imageGuid = _image?.value;
                if (isValidGuid(imageGuid)) {
                    const image = await SimpliCitySDK.image.findOne(token, imageGuid);
                    return {
                        src: image?.url,
                        width: image.width || 1920,
                        height: image.height || 1080,
                    };
                }
            })
    );
    return imageSlides;
};

export const IMAGE_GALLERY_TYPES = {
    FILMSTRIP: "thumbnail",
    CAROUSEL: "slider",
    GRID: "grid",
    COLLAGE: "masonry",
};
